import React from 'react';
import ReactDOM from 'react-dom/client';
import MainApp from 'app/main';

const root = ReactDOM.createRoot(document.getElementById('app-site'));
root.render(<MainApp />);
